var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "10px",
    height: "14px",
    viewBox: "0 0 10 14",
    enableBackground: "new 0 0 10 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 10,
    height: 14,
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAMAAAAhfX2ZAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABvUExURf/////Jyf/s7P8eHv8hIf/u7v/+/v9LS/8AAP9Q UP+Li/+Kiv/Dw/8EBP8GBv/Hx//r6/8cHP8fH//t7fX19aKiop2dncnJyXp6eqenp6urq/j4+I2N jY+Pj/n5+ebm5n5+fn9/f+jo6M3NzczMzNd8NhIAAAABYktHRACIBR1IAAAACXBIWXMAAABgAAAA YADwa0LPAAAAB3RJTUUH5wYGBhcceLGPjQAAAFhJREFUCNdty0cSgDAIQFFiidhbNLHX+5/RQHTn WzB/GACwhICX5wehKxkhxpIzQSulynLKogSoamRNC/9U17NOAWjDNO0HqpFPptmYZXXn236c3+t1 03wADbME0PRqT6YAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMDYtMDZUMDY6MjM6MjgrMDA6MDCZ 3T1AAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTA2LTA2VDA2OjIzOjI4KzAwOjAw6ICF/AAAACh0 RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0wNi0wNlQwNjoyMzoyOCswMDowML+VpCMAAAAASUVORK5C YII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.334d84072bc146163167e24b0ce85a2a.svg";
export { ForwardRef as ReactComponent };